import queryGQL from "@/Apollo/query/sellerPayouts.graphql";
import { QueryHookOptions, useQuery } from "@apollo/client";
import {
  SellerPayoutsQuery,
  SellerPayoutsQueryVariables,
} from "@whoppah/apollo/schema";

/** The seller's own recent payouts to their bank, newest first. */
export const useSellerPayouts = (
  options?: QueryHookOptions<SellerPayoutsQuery, SellerPayoutsQueryVariables>
) => {
  return useQuery(queryGQL, options);
};
